import { LINE_BREAK_TAG, EMPTY_SPACE } from '@constants';

export const getStringFromArray = (strings: string[], asSingleSentence?: boolean) => {
  if (asSingleSentence) {
    return strings.join(EMPTY_SPACE);
  } else {
    return strings.join(LINE_BREAK_TAG);
  }
};
